import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { API_BASE_URL } from "../Config";
import { useTranslation } from 'react-i18next';

function ContactFormScreen() {
  const { t, i18n } = useTranslation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [messageText, setMessageText] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const languageLocale = i18n.language;

      const response = await fetch(`${API_BASE_URL}/api/contact/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ name, email, subject, message: messageText, languageLocale }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.detail || t('message_send_error'));
      } else {
        const data = await response.json();
        setMessage(data.detail || t('message_sent_success'));
        setName(""); 
        setEmail("");
        setSubject("");
        setMessageText("");
        setError(null);
      }
    } catch (error) {
      setError(t('message_send_error'));
      console.error(`${t('message_send_error')}:`, error);
    }
  };

  return (
    <Container className="pt-4">
      <Row>
        <Col lg={5} md={6} className="align-items-center m-auto">
          <h2 className="h4 mb-4">{t('contact_us')}</h2>
          <Form onSubmit={handleSubmit} className="p-4 mt-4 mt-md-0 m-auto forms">
            {message && (
              <Alert variant="success" onClose={() => setMessage(null)} dismissible>
                {message}
              </Alert>
            )}
            {error && (
              <Alert variant="danger" onClose={() => setError(null)} dismissible>
                {error}
              </Alert>
            )}
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label>{t('name')}</Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>{t('email')}</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formSubject">
              <Form.Label>{t('subject')}</Form.Label>
              <Form.Control
                as="select"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              >
                <option value="">{t('select_subject')}</option>
                <option value="reclamacao">{t('complaint')}</option>
                <option value="devolucao">{t('return')}</option>
                <option value="suporte">{t('support')}</option>
                <option value="informacoes">{t('information')}</option>
                <option value="sugestao">{t('suggestion')}</option>
                <option value="elogio">{t('compliment')}</option>
                <option value="outros">{t('other')}</option>
              </Form.Control>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formMessage">
              <Form.Label>{t('message')}</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mb-3 me-2" title={t('submit')}>
              {t('submit')}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default ContactFormScreen;
